import { getOrder } from '@wix/ambassador-ecom-v1-order/http';
import { factory, orderSanitizer } from '@wix/restaurants-api';
import { Order } from '@wix/restaurants-types';
import { FlowApi } from '../components/trackingPage/utils/types';

export async function getOrderInfo(
  flowAPI: FlowApi,
  orderId: string,
): Promise<Order> {
  const transaction = flowAPI.panoramaClient?.transaction('getOrder');
  transaction?.start();

  try {
    const {
      data: { order },
    } = await flowAPI.errorHandler.withErrorHandler(
      () =>
        flowAPI.httpClient.request(
          getOrder(factory.requestOptions.getOrder(orderId)),
        ),
      {
        errorCodesMap: {
          applicationError: {
            ORDER_NOT_FOUND: () => ({
              message: 'Order not found',
            }),
          },
        },
      },
    );

    if (!order) {
      throw new Error(
        `[Order Tracker] - get Order: Error when calling getOrder, Get empty order for orderId ${orderId}.`,
      );
    }

    transaction?.finish();

    return orderSanitizer(order);
  } catch (e) {
    flowAPI.panoramaClient?.errorMonitor().reportError(
      new Error('get order - failed to get order', {
        cause: e,
      }),
    );

    throw e;
  }
}
